import { getUXState } from '../reducers';
import { createSelector } from '@ngrx/store';

export const getPaginationState = createSelector(getUXState, state => state.pagination);

export const getCurrentPage = createSelector(getPaginationState, state => state.currentPage);
